module.exports = __webpack_public_path__ + "static/media/97.c357b42f.jpg";